import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  beta: { id: 'gofre.Ui.Tabs.Tab.beta' },
  notifications: { id: 'gofre.Ui.Tabs.Tab.notification' },
});
